import { Filters } from '@/features/product-reviews/ui/Filters';
import { Button } from '@/shared/ui/Button';
import { cva } from 'class-variance-authority';
import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

interface Props {
  className?: string;
  filter: ReviewsFilter;
  onChange?: (value: ReviewsFilter) => void;
}

export type ReviewsFilter = {
  type: 'all' | 'with_photo';
  sort: 'asc' | 'desc';
};

export const ProductReviews: FC<Props> = ({ className, filter, onChange }) => {
  return (
    <div className={twMerge(cvaRoot(), className)}>
      <div className={cvaLeft()}>
        <Button
          color={'outlined32'}
          className={cvaButton({
            active: filter.type === 'all',
          })}
          onClick={() => onChange?.({ ...filter, type: 'all' })}
          wrapperClassName={'text-[1.6rem]'}
        >
          Все отзывы
        </Button>
        <Button
          color={'outlined32'}
          className={cvaButton({
            active: filter.type === 'with_photo',
          })}
          onClick={() =>
            onChange?.({
              ...filter,
              type: 'with_photo',
            })
          }
          wrapperClassName={'text-[1.6rem]'}
        >
          С фото или видео
        </Button>
      </div>
      <div className={cvaRight()}>
        <Filters values={filter} onChange={onChange} />
      </div>
    </div>
  );
};

const cvaRoot = cva(['ProductReviews-cvaRoot', 'flex items-center justify-between gap-0.8', 'w-full max-w-[60.2rem]']);

const cvaLeft = cva(['ProductReviews-cvaLeft', 'flex items-center gap-0.8']);

const cvaRight = cva(['ProductReviews-cvaRight', 'flex items-center gap-0.8']);

const cvaButton = cva(['ProductReviews-cvaButton', 'py-1.1 px-1.6 pb-1.3', 'rounded-[1.6rem]'], {
  variants: {
    active: {
      true: ['bg-cMediumGreyOnWhite border-cMediumGreyOnWhite'],
      false: [''],
    },
  },
  defaultVariants: {
    active: false,
  },
});
